import {SearchIcon as DefaultSearchIcon} from '../Search/SearchIcon';
import type {ComponentType} from 'react';
import {forwardRef} from 'react';
import type {AutocompleteProps} from '../Autocomplete/Autocomplete';
import {Autocomplete} from '../Autocomplete/Autocomplete';
import {InputAdornment} from '../Input/InputAdornment';
import type {FuelInputVariant} from '../types/general';

export interface SearchAutocompleteProps extends AutocompleteProps {
    /**
     * The default React Icon Component used to render the the search icon.
     * @default Search
     */
    SearchIcon?: ComponentType;
    /**
     * Search variants. Sets Input variant.
     * @default 'outlined'
     */
    variant?: FuelInputVariant;
}

export const SearchAutocomplete = forwardRef<any, SearchAutocompleteProps>(({
    SearchIcon = DefaultSearchIcon, InputProps, placeholder = 'Search', variant = 'outlined', ...props
}, ref) => (
    <Autocomplete
        {...props}
        InputProps={{
            ...InputProps,
            placeholder: InputProps?.placeholder || placeholder,
            variant: InputProps?.variant || variant,
            startAdornment:
                InputProps?.startAdornment || (
                    <InputAdornment position='start'>
                        <SearchIcon/>
                    </InputAdornment>
                )
        }}
        ref={ref}
    />
));

SearchAutocomplete.displayName = 'SearchAutocomplete';
